import React from "react";
import PropTypes from "prop-types";
import { useForm } from "react-hook-form";
import styled from "styled-components";
import Button from "../FormNew/Button";
import TextArea from "../FormNew/TextArea";
import TextBox from "../FormNew/TextBox";
import Select from "../FormNew/Select";

const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  min-height: 50vh;
`;

export const Nav = styled.div`
  border-top: ${({ theme }) => `1px solid ${theme.colors.lightGray}`};
  padding-top: 20px;
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;

  button {
    &:last-child {
      margin-left: 10px;
    }
  }
`;

const Fields = styled.div`
  h3 {
    font-size: 2.5rem;
    font-weight: 500;
    margin-bottom: 10px;
  }

  p {
    font-size: 1.4rem;
    font-weight: 400;
    margin-bottom: 30px;
  }
`;

const Error = styled.span`
  padding: 10px;
  background: ${({ theme }) => theme.colors.error};
  color: ${({ theme }) => theme.colors.white};
  width: 100%;
  display: block;
  border-radius: 5px;
`;

const Input = ({
  name,
  title,
  defaultValue,
  errors,
  register,
  options,
  placeholder,
  type = "input",
  autoComplete = "off",
}) => (
  <>
    <label htmlFor={name}>
      {title}
      {type === "dropdown" && (
        <Select
          items={options}
          defaultValue={defaultValue}
          name={name}
          register={register}
        />
      )}
      {type === "upload" && <>upload</>}
      {type === "textbox" && (
        <TextBox
          defaultValue={defaultValue}
          register={register}
          name={name}
          autoComplete={autoComplete}
          placeholder={placeholder}
        />
      )}
      {type === "textarea" && (
        <TextArea
          defaultValue={defaultValue}
          register={register}
          name={name}
          placeholder={placeholder}
        />
      )}
    </label>
    {errors[name] && <Error>{errors[name].message}</Error>}
  </>
);

export default function OrderForm({ form, defaultData, loading }) {
  const {
    schema,
    fields,
    handlePrev,
    handleNext,
    prevText,
    nextText,
    name,
    title,
    description,
  } = form;

  const { register, errors, handleSubmit } = useForm({
    validationSchema: schema,
  });

  return (
    <Form onSubmit={handleSubmit(handleNext)} key={name}>
      <Fields>
        <h3>{title}</h3>
        <p>{description}</p>
        {fields.map(
          ({
            name: fieldName,
            displayName,
            autoComplete,
            type,
            options,
            placeholder,
          }) => (
            <Input
              name={fieldName}
              key={fieldName}
              title={displayName}
              defaultValue={defaultData[fieldName]}
              autoComplete={autoComplete}
              errors={errors}
              register={register}
              type={type}
              options={options}
              placeholder={placeholder}
            />
          )
        )}
      </Fields>

      <Nav>
        {handlePrev && (
          <Button type="button" onClick={handlePrev} color="gray">
            {prevText}
          </Button>
        )}
        {handleNext && (
          <Button type="submit" loading={loading}>
            {nextText}
          </Button>
        )}
      </Nav>
    </Form>
  );
}

OrderForm.defaultProps = {
  loading: false,
};

OrderForm.propTypes = {
  form: PropTypes.shape().isRequired,
  defaultData: PropTypes.shape().isRequired,
  loading: PropTypes.bool,
};
